/*
 * @Description  :
 * @Author       : 王帅
 * @Date         : 2024-06-07 08:55:21
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-28 16:26:45
 * @FilePath     : \ngs_share_login\src\main.js
 */


import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import XEUtils from 'static/xe-utils'

import ElementUI from 'element-ui'

import 'assets/baseStyle/layout.less'
import 'assets/baseStyle/transition.less'
import 'assets/baseStyle/quill.css'

import bmComponents from 'bm-components'
Vue.use(bmComponents)

// svg 组件
import '@/icons' // icon
import './utility/extends' // js 浮点数计算
// 原型函数
import 'utility/prototype.js'

// 全局inputFilter
import inputFilter from 'utility/input-filter/index.js'
Vue.use(inputFilter)

import newUpload from 'components/w-upload/newUpload'
Vue.component('newUpload', newUpload)

// 面包屑
import BreadCrumb from 'components/breadcrumb/breadcrumb'
Vue.component('BreadCrumb', BreadCrumb)

// 缺省页
import pending from 'components/pending/Pending'
Vue.component('Pending', pending)

import myWebsocket from "utility/websocket.js"

Vue.prototype.mySocket = new myWebsocket();

// 本末工具函数插件
import 'static/commonplugin/Array.min.js'
import { bmTooljs, bmStorage } from 'static/commonplugin/tool'
import { bmDataCheck } from 'static/commonplugin/dataCheck'
import { bmElementFormRules } from 'static/commonplugin/elementFormRules'

Vue.use(ElementUI, { size: 'small' })

window.bmTooljs = bmTooljs
window.bmStorage = bmStorage
window.bmDataCheck = bmDataCheck
window.bmElementFormRules = bmElementFormRules

Vue.prototype.$utils = XEUtils

// 路由设置标题
router.beforeEach(async (to, from, next) => {
    // 设置页面标题
    document.title = to.meta.title ? `${to.meta.title} - 能工社平台` : '能工社平台'

    next()
})

// 注册全局 企业中心地址、 websocket 地址
let personUrl = '',homeUrl='', companyUrl = '',  expertUrl = '', lwtWebUrl = '', xjtWebUrl = '', jytWebUrl = '', azcWebUrl = ''
if (process.env.NODE_ENV === 'dev') {
	personUrl = 'http://' + window.location.hostname + ':9000'
	companyUrl = 'http://' + window.location.hostname + ':9002'
	expertUrl = 'http://' + window.location.hostname + ':8085'
	homeUrl =  'http://' + window.location.hostname + ':8086'
} else {
	personUrl = window.location.origin + '/NgsPersonAdmin/'
	companyUrl = window.location.origin + '/NgsTenantAdmin/'
	homeUrl = window.location.origin + '/NgsHomeWeb/'
	azcWebUrl = window.location.origin + '/NgsAzcWeb/'
	expertUrl = window.location.origin + '/NgsZjtWeb/'
	lwtWebUrl = window.location.origin + '/NgsLwtWeb/'
	xjtWebUrl = window.location.origin + '/NgsXjtWeb/'
	jytWebUrl = window.location.origin + '/NgsJytWeb/'
}

window.personUrl = personUrl
window.companyUrl = companyUrl
window.azcWebUrl = azcWebUrl
window.expertUrl = expertUrl
window.lwtWebUrl = lwtWebUrl
window.xjtWebUrl = xjtWebUrl
window.jytWebUrl = jytWebUrl
window.homeUrl = homeUrl

new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js